import "@/App.css";
import { useState, useEffect } from "react";
import Lenis from "@studio-freight/lenis";
import { Navigation } from "./components/Navigation";
import { Hero } from "./components/Hero";
import { About } from "./components/About";
import { Marquee } from "./components/Marquee";
import { Experience } from "./components/Experience";
import { Expertise } from "./components/Expertise";
import { TrustedBy } from "./components/TrustedBy";
import { Projects } from "./components/Projects";
import { Testimonials } from "./components/Testimonials";
import { Consulting } from "./components/Consulting";
import { BookCall } from "./components/BookCall";
import { Contact } from "./components/Contact";
import { Footer } from "./components/Footer";
import { FloatingActions } from "./components/FloatingActions";
import { CustomCursor } from "./components/CustomCursor";
import { Preloader } from "./components/Preloader";
import { DarkModeToggle } from "./components/DarkModeToggle";

function App() {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Initialize Lenis smooth scroll
    const lenis = new Lenis({
      duration: 1.2,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      direction: "vertical",
      gestureDirection: "vertical",
      smooth: true,
      smoothTouch: false,
      touchMultiplier: 2,
    });

    function raf(time) {
      lenis.raf(time);
      requestAnimationFrame(raf);
    }

    requestAnimationFrame(raf);

    return () => {
      lenis.destroy();
    };
  }, []);

  return (
    <>
      {/* Preloader */}
      {isLoading && <Preloader onComplete={() => setIsLoading(false)} />}

      {/* Main App */}
      <div className={`App ${isLoading ? 'invisible' : 'visible'}`} data-testid="app-container">
        {/* Custom Cursor */}
        <CustomCursor />

        {/* Grain Texture Overlay */}
        <div className="grain" />

        {/* Dark Mode Toggle */}
        <DarkModeToggle />

        {/* Navigation */}
        <Navigation />

        {/* Main Content */}
        <main>
          <Hero />
          <About />
          <Marquee />
          <Experience />
          <Expertise />
          <TrustedBy />
          <Projects />
          <Testimonials />
          <Consulting />
          <BookCall />
          <Contact />
        </main>

        {/* Footer */}
        <Footer />

        {/* Floating Actions */}
        <FloatingActions />
      </div>
    </>
  );
}

export default App;
